import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';

export default function HostAgreementPage() {
  const navigate = useNavigate();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#050505]">
      {/* Header */}
      <header className="border-b border-white/10">
        <div className="max-w-4xl mx-auto px-6 py-6">
          <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-zinc-400 hover:text-white transition-colors">
            <ArrowLeft size={20} />
            <span>Go Back</span>
          </button>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-serif text-white mb-4">Host Agreement</h1>
          <p className="text-zinc-400">Last Updated: April 2026</p>
        </div>

        <div className="space-y-10 text-zinc-300">
          {/* Section 1 */}
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">1. Host Eligibility</h2>
            <p className="mb-4">Hosts must:</p>
            <ul className="list-disc list-inside space-y-2 text-zinc-400">
              <li>Own or control property</li>
              <li>Have authority to list</li>
              <li>Comply with local laws</li>
            </ul>
          </section>

          <hr className="border-white/10" />

          {/* Section 2 */}
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">2. Listings</h2>
            <p className="mb-4">Hosts must provide:</p>
            <ul className="list-disc list-inside space-y-2 text-zinc-400">
              <li>Accurate description</li>
              <li>Photos</li>
              <li>Availability</li>
              <li>Rules</li>
            </ul>
          </section>

          <hr className="border-white/10" />

          {/* Section 3 */}
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">3. Safety Requirements</h2>
            <p className="mb-4">Hosts agree to:</p>
            <ul className="list-disc list-inside space-y-2 text-zinc-400">
              <li>Maintain safe environment</li>
              <li>Warn of hazards</li>
              <li>Provide clear instructions</li>
            </ul>
          </section>

          <hr className="border-white/10" />

          {/* Section 4 */}
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">4. Insurance</h2>
            <p className="mb-4 font-semibold text-white">Hosts responsible for:</p>
            <ul className="list-disc list-inside space-y-2 text-zinc-400 mb-4">
              <li>Property insurance</li>
              <li>Liability coverage</li>
            </ul>
            <p className="text-zinc-500">100Nook does not provide host insurance.</p>
          </section>

          <hr className="border-white/10" />

          {/* Section 5 */}
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">5. Host Responsibilities</h2>
            <p className="mb-4">Hosts responsible for:</p>
            <ul className="list-disc list-inside space-y-2 text-zinc-400">
              <li>Guest safety</li>
              <li>Property safety</li>
              <li>Compliance</li>
            </ul>
          </section>

          <hr className="border-white/10" />

          {/* Section 6 */}
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">6. Payouts</h2>
            <p className="mb-4">Hosts receive payouts via:</p>
            <ul className="list-disc list-inside space-y-2 text-zinc-400 mb-4">
              <li>Stripe</li>
              <li>Bank transfer</li>
            </ul>
            <p className="text-zinc-500">After booking completion.</p>
          </section>

          <hr className="border-white/10" />

          {/* Section 7 */}
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">7. Host Liability</h2>
            <p className="mb-4">Hosts assume liability for:</p>
            <ul className="list-disc list-inside space-y-2 text-zinc-400">
              <li>Injury</li>
              <li>Damage</li>
              <li>Disputes</li>
            </ul>
          </section>

          <hr className="border-white/10" />

          {/* Section 8 */}
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">8. Listing Removal</h2>
            <p className="text-zinc-400">100Nook may remove listings at any time.</p>
          </section>
        </div>

        {/* Footer CTA */}
        <div className="mt-16 pt-8 border-t border-white/10">
          <p className="text-zinc-500 text-sm">
            Questions about the Host Agreement? Contact us at{' '}
            <a href="mailto:admin@100nook.com" className="text-[#D4AF37] hover:underline">
              admin@100nook.com
            </a>
          </p>
        </div>
      </main>
    </div>
  );
}
